/**
 * Authentication Service which deals with authenticating the user and returning access tokens
 * to access microsoft graph API and timesheet API
 */
import * as Msal from 'msal'

export default class AuthService {
  constructor() {
    this.msalConfig = {
      auth: {
          clientId: process.env.VUE_APP_CLIENT_ID, // This is your client ID
          authority: process.env.VUE_APP_AUTHORITY, // This is your authority/tenant info
          redirectUri: process.env.VUE_APP_PWA_URL // redirect url to website
      },
      cache: {
          cacheLocation: "localStorage", // user info stored in cache
          storeAuthStateInCookie: true
      }
    };
    // scope
    this.requestObj = {
      scopes: ["user.read", "email", "Mail.Send"]
    };
    this.msal = new Msal.UserAgentApplication(this.msalConfig)
    this.msal.handleRedirectCallback(this.authRedirectCallBack)
    }

    /**
     * Redirect callback
     * @param {*} error 
     * @param {*} response 
     */
    authRedirectCallBack(error, response) {
      if (error) {
        console.log(error);
    } else {
        if (response.tokenType === "access_token") {
            console.log("Login Successful")
        } else {
            console.log("token type is:" + response.tokenType);
        }
      } 
    }

    /**
     * Redirects to Microsoft login to authenticate the user
     */
    login() {
      console.log("Signing In...")
      this.msal.loginRedirect(this.requestObj)
    }

    /**
     * Get MS graph access token
     */
    getMSGraphToken() {
      var self = this
      return this.msal.acquireTokenSilent(this.requestObj).then(token => {
        return token.accessToken
      }, err => {
        console.log("CALL TOKEN REDIRECT ")
        self.msal.acquireTokenRedirect(self.requestObj)
      })
    }

    /**
     * Returns true if the user is authenticated, else false
     */
    isAuthenticated() {
      return this.msal.getAccount() != null
    }

    /**
     * Logout of the app
     */
    logout() {
      this.msal.logout();
    }
  }